import React, { FC } from 'react'
import { Flex, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { useProductsLocaleText } from '../../locale'

const StyledLabel = styled(Text)`
  ${s({
    m: 0,
    p: 0,
    mb: 4,
    color: 'colorTextHeadline',
    typography: { xs: 'typeMobileDisplay03', md: 'typeDesktopDisplay05' },
  })}
`

const StyledBasePrice = styled(Text)<{
  discount: number
}>`
  ${({ discount }) => `
    text-decoration: ${discount ? 'line-through' : 'none'};
  `}
`

const StyledDiscountedPrice = styled(Text)`
  ${s({
    ml: 3,
    color: 'colorFeedbackSuccess',
    fontWeight: 'bold',
  })}
`

type Props = {
  code: string
  discount: number
  regularTotalPrice: string
  discountedTotalPrice: string
  discountText: string
}

export const DefaultVariant: FC<Props> = ({
  code,
  discount,
  regularTotalPrice,
  discountedTotalPrice,
  discountText,
}) => {
  const localiseCoreText = useCoreLocaleText()
  const localiseText = useProductsLocaleText()

  return (
    <Flex
      alignContent="center"
      justifyContent="space-between"
      data-testid="module-price"
      mb={6}
    >
      <StyledLabel data-testid="price-title">
        {localiseCoreText('common.price')}
      </StyledLabel>
      <Flex flexDirection="column" alignItems="end">
        <Text
          as="p"
          color={'colorTextHeadline'}
          mb={0}
          aria-label={localiseText(
            'multicard.regular_price_and_discounted_price',
            {
              regularPrice: regularTotalPrice,
              discountedPrice: discountedTotalPrice,
              code,
              discount,
            },
          )}
        >
          <StyledBasePrice discount={discount} aria-hidden>
            {regularTotalPrice}
          </StyledBasePrice>
          <StyledDiscountedPrice aria-hidden>
            {discountedTotalPrice}
          </StyledDiscountedPrice>
        </Text>
        <Text
          as="p"
          color="colorFeedbackSuccess"
          fontWeight="bold"
          mb={0}
          aria-hidden
        >
          {discountText}
        </Text>
      </Flex>
    </Flex>
  )
}
